import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from '../lecture-api'
import { Event } from '../../models/event'

@Injectable()
export abstract class EventApi {
  abstract apiPath(resourceId: number, eventId?)

  constructor(
    private api: LectureApiBase,
  ) {}

  index(resourceId: number): Observable<Event[]> {
    return this.api.listWithObject(Event, this.apiPath(resourceId))
  }

  all(resourceId: number, groupIds?: number[]): Observable<Event[]> {
    return this.api.listWithObject(Event, this.api.makeUrlWithParams(`${this.apiPath(resourceId, 'all')}`, { groupIds }))
  }

  group(resourceId: number): Observable<Event[]> {
    return this.api.listWithObject(Event, `${this.apiPath(resourceId, 'group')}`)
  }

  post(resourceId: number, kind: string): Observable<Event> {
    return this.api.postWithObject(Event, this.apiPath(resourceId),
      {
        event: { kind }
      }
     )
  }

  directPost(resourceId: number, payload: any): Observable<Event> {
    return this.api.postWithObject(Event, this.apiPath(resourceId),
      {
        direct: true,
        event: payload
      }
    )
  }

  delete(resourceId: number, eventId: number): Observable<any> {
    return this.api.delete(this.apiPath(resourceId, eventId.toString()))
  }
}



// WEBPACK FOOTER //
// ./src/apis/event/base.ts